import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/index.vue'
import { rootRoutes, moduleRoutes } from './generated-routes'

/**
 * ============================================================================
 * 路由表
 * ============================================================================
 *
 * 说明：所有页面路由由 scripts/gen-registry.mjs 生成到 generated-routes.ts，
 * 本文件只负责「组装」：登录页独立、其余页面统一挂在同一个 Layout 下。
 *
 * 关键点：必须挂在同一个 Layout 实例下，否则切换模块时 Layout 会重新挂载，
 * 侧边栏折叠状态、页签等会丢失。
 */

const LOGIN_ROUTE: RouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('@/views/login/index.vue'),
  meta: { title: '登录', public: true, hideTab: true }
}

/** 平台基础页面（登录之外：门户首页等；系统维护页单独实现，故排除） */
const baseChildren: RouteRecordRaw[] = rootRoutes
  .filter((r) => r.path !== 'login' && r.path !== 'systemMaintenance')
  .map((r) => ({ ...r, path: r.path.replace(/^\//, '') }))

/** 业务模块页面：把「模块 + 子页」压平成 Layout 的直接子路由 */
const businessChildren: RouteRecordRaw[] = moduleRoutes.flatMap((m) => {
  const moduleKey = String(m.path).replace(/^\//, '')
  return (m.children || []).map((c) => ({
    ...c,
    path: `${moduleKey}/${c.path}`
  }))
})

const routes: RouteRecordRaw[] = [
  LOGIN_ROUTE,
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      ...baseChildren,
      ...businessChildren,
      {
        path: 'systemMaintenance',
        name: 'SystemMaintenance',
        component: () => import('@/views/common/SystemMaintenance.vue'),
        meta: { title: '系统维护中', public: true, hideTab: true }
      },
      {
        path: 'migration',
        name: 'MigrationBoard',
        component: () => import('@/views/common/MigrationBoard.vue'),
        meta: { title: '迁移进度看板', hideTab: true }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/common/404.vue'),
    meta: { title: '页面不存在', public: true, hideTab: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 })
})

export default router
export { routes }
